"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerAnuncio = void 0;
var React = require("react");
var FetchAnuncios_1 = require("./FetchAnuncios");
var ai_1 = require("react-icons/ai");
var reactstrap_1 = require("reactstrap");
//import imgAnuncio from "./img-anuncio.JPG";
var url_js_1 = require("../variables/url.js");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var enlace = localBack + 'api/Catalog/receptor/';
var log = localBack + 'api/Catalog/receptor/log/';
var interacciones = localBack + 'api/catalog/interacciones';
var categorias = localBack + 'api/Catalog/Categorias';
var VerAnuncio = /** @class */ (function (_super) {
    __extends(VerAnuncio, _super);
    function VerAnuncio(props) {
        var _this = _super.call(this, props) || this;
        _this.addLike = function () {
            _this.setState({ signal: 0 });
            var data = JSON.stringify({ "idAnuncio": _this.state.dtoData.idAnuncio, "bdTipo": "L" });
            fetch(interacciones, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + espolAds_1.getCookie('token')
                },
                body: data,
            }).then(function (response) {
                _this.setState({ signal: response.status });
            });
            if (_this.state.pulgar == "0") {
                _this.setState({
                    pulgar: "1",
                });
            }
            else {
                _this.setState({
                    pulgar: "0",
                });
            }
        };
        _this.state = {
            title: "",
            loading: true, dtoData: new FetchAnuncios_1.AnunciosData,
            status: 0, signal: 200,
            categoriaList: [],
            consulta: 'http://localhost:3368/api/Catalog/receptor/',
            login: false,
            pulgar: "0",
        };
        fetch(categorias)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit employee  
        if (dtoid > 0) {
            if (!espolAds_1.checkCookie('token')) {
                fetch(enlace + dtoid, {
                    method: 'GET',
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (data) {
                    _this.setState({ title: "Edit", loading: false, dtoData: data, login: false });
                });
            }
            else {
                fetch(log + dtoid, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (data) {
                    _this.setState({ title: "Edit", loading: false, dtoData: data["anuncio"], login: true, pulgar: data["bdInteraccion"] });
                });
            }
        }
        _this.isDisabled = _this.isDisabled.bind(_this);
        return _this;
    }
    VerAnuncio.prototype.isDisabled = function () {
        if (this.state.signal == 200) {
            return false;
        }
        else {
            return true;
        }
    };
    ;
    VerAnuncio.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    VerAnuncio.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderAnuncio(this.state.categoriaList);
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "ANUNCIO")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    // Returns the HTML Form to the render() method.  
    VerAnuncio.prototype.renderAnuncio = function (categoriaList) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardBody, { className: "main-content mb-12" },
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "6" },
                                        React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                            React.createElement("a", { href: this.state.dtoData.txUrl, target: "_blank" },
                                                React.createElement("img", { src: this.state.dtoData.txImagen, alt: "anuncio", className: "img-fluid" })))),
                                    React.createElement(reactstrap_1.Col, { sm: "6" },
                                        React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                            React.createElement("h5", null, this.state.dtoData.txTitulo),
                                            React.createElement(reactstrap_1.CardText, null,
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Tipo:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdTipo == "E" ? "Evento" : "Anuncio")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Ambito:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdAmbito == "A" ? "Abierto" : "Interno")),
                                                this.state.dtoData.bdTipo == 'A' ? React.createElement(React.Fragment, null) : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Duraci\u00F3n Evento:"),
                                                    " ",
                                                    React.createElement("strong", null,
                                                        "\u00A0\u00A0 desde \u00A0\u00A0",
                                                        this.state.dtoData.dtInicio.split("T")[0],
                                                        "\u00A0\u00A0"),
                                                    " - ",
                                                    React.createElement("strong", null,
                                                        "\u00A0\u00A0 hasta \u00A0\u00A0 ",
                                                        this.state.dtoData.dtFin.split("T")[0])),
                                                React.createElement("div", { className: "form-group row", hidden: true },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Categor\u00EDa:"),
                                                    categoriaList.map(function (categoria) {
                                                        if (_this.state.dtoData.idCategoria == categoria.idCategoria)
                                                            return React.createElement("strong", { key: categoria.idCategoria, className: "valor" },
                                                                " \u00A0\u00A0",
                                                                categoria.txNombreCategoria);
                                                    })),
                                                this.state.dtoData.txUrl == null ? null : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Enlace:"),
                                                    " ",
                                                    React.createElement("a", { href: this.state.dtoData.txUrl, target: "_blank" },
                                                        " \u00A0\u00A0",
                                                        React.createElement("strong", null, this.state.dtoData.txUrl.length > 60 ? React.createElement(React.Fragment, null, this.state.dtoData.txUrl.substring(0, 60) + "...") : React.createElement(React.Fragment, null, "" + this.state.dtoData.txUrl.substring(0, 60))))),
                                                this.state.dtoData.txLugar == null ? null : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Lugar:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.txLugar)),
                                                React.createElement("div", { className: "form-group row", hidden: true },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "\u00C1mbito:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdAmbito == "A" ? "Abierto" : "Interno")),
                                                React.createElement("div", { className: "form-group row mb-10 titulo-anuncio" },
                                                    "Descripci\u00F3n: ",
                                                    React.createElement("br", null)),
                                                React.createElement("div", { className: "form-group row valor" },
                                                    React.createElement("p", null,
                                                        React.createElement("strong", null, this.state.dtoData.txTexto))),
                                                this.state.login ?
                                                    React.createElement("div", { id: "botones" },
                                                        React.createElement("button", { id: "like", title: "like", className: "btn-round-like", onClick: this.addLike, disabled: this.isDisabled() }, this.state.pulgar == "0" ? React.createElement(ai_1.AiOutlineLike, { className: "likeboton" }) : React.createElement(ai_1.AiTwotoneLike, { className: "likeboton" })),
                                                        "\u00A0\u00A0")
                                                    :
                                                        React.createElement(React.Fragment, null))))))))))));
    };
    return VerAnuncio;
}(React.Component));
exports.VerAnuncio = VerAnuncio;
//# sourceMappingURL=VerAnuncio.js.map